import { GUIDE_NAME, WA_NUMBER, WA_MESSAGES } from '../../constants'

export default function TrekGuideBlock({ trek }) {
  const waMessage = WA_MESSAGES[trek.waKey] || WA_MESSAGES.general

  return (
    <div style={{
      marginBottom: '48px',
      background: 'var(--color-background)',            // warm paper
      border: '1px solid var(--color-rule)',            // hairline map-rule
      borderRadius: 'var(--radius-lg)',
      padding: '32px',
      display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* gold hairline accent along the top edge — the human-moment marker */}
      <div style={{ position: 'absolute', top: 0, left: 0, width: '56px', height: '3px', background: 'var(--color-accent-warm)' }} />

      {/* Documentary-but-personal portrait. Gold ring warms the initials until a
          real photo of the guide is supplied. */}
      <div style={{
        width: '92px', height: '92px', borderRadius: '50%',
        background: 'rgba(219,160,90,0.16)', border: '2px solid var(--color-accent-warm)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--color-text)',
        fontWeight: 600, fontSize: '34px', fontFamily: 'var(--font-heading)', flexShrink: 0,
      }}>
        {GUIDE_NAME.charAt(0)}
      </div>

      <div style={{ flex: 1, minWidth: '240px' }}>
        <h3 style={{ fontSize: '22px', fontWeight: 600, fontFamily: 'var(--font-heading)', marginBottom: '6px' }}>
          {GUIDE_NAME}
        </h3>
        <div className="data" style={{ fontSize: '12px', color: 'var(--color-accent-cool)', marginBottom: '12px' }}>
          Licensed local guide
        </div>
        <p style={{ fontSize: '14px', color: 'var(--color-text)', lineHeight: 1.6, marginBottom: '18px', maxWidth: '460px' }}>
          Every trek on this page, I guide personally — you plan it directly with me, not a call centre.
        </p>
        <a
          href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(waMessage)}`}
          target="_blank" rel="noreferrer"
          className="btn btn-green btn-sm"
        >
          Message {GUIDE_NAME}
        </a>
      </div>
    </div>
  )
}
